import React, { useState } from "react";
import { Link } from "react-router-dom"


const FolderItemView = ({
  folder,
  selectedFolder,
  setSelectedFolder
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = () => {
    setIsHovered(true);
  };

  const onMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <li class="nav-item" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <a class={`nav-link ${selectedFolder == folder.id ? "active" : ""}`}
        title={folder.name} style={{ cursor: "pointer" }}
        onClick={() => setSelectedFolder(folder.id)}>
        <i class="fas fa-folder mr-3 ml-3"></i>
        {folder.isHidingFlows && <i class="fas fa-eye-slash hidden-icon"></i>}
        <span class="text-truncate">{folder.name}</span>
        {isHovered && (
          <div className="ml-3">
            <Link to={`/${folder.id}/edit_folder`}
              onClick={e => e.stopPropagation()}>
              <i class="fas fa-pen"></i>
            </Link>
          </div>
        )}
      </a>
    </li>
  )
}

export default FolderItemView;